<!--
 * @Author: Nie Wie
 * @Date: 2020-02-21 14:15:02
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-04-09 16:11:15
 * @Description: 观测时报---覆盖率地图模式
 -->
<template>
  <div class="observe-cover-map">
    <part-title title="覆盖率统计"></part-title>
    <div class="observe-cover-map__map" ref="hChart"></div>
    <div class="observe-cover-map__timeline" ref="time-line"></div>
  </div>
</template>

<script>
import moment from 'moment'
import Highcharts from 'highcharts/highmaps'
import PartTitle from '@/components/part-title'
import {
  COVERAGE_TIMELINE_DATA,
} from '@/assets/const-value'
import {
  GET_STATISTICS,
} from '@/assets/const-value/interface'
import Timeline from '@/assets/plugins/timeline'
import {
  guojieData,
  daoyuData,
  provinceData,
} from '@/assets/const-value/map-svg-path'

moment.locale('fr', {
  week: {
    dow: 1, // 星期一是一周的第一天
    doy: 4, // 判断一年中的第一周
  },
})
const REGIONSLIST = {
  100000: '中国',
  110000: '北京',
  120000: '天津',
  130000: '河北',
  140000: '山西',
  150000: '内蒙古',
  210000: '辽宁',
  220000: '吉林',
  230000: '黑龙江',
  310000: '上海',
  320000: '江苏',
  330000: '浙江',
  340000: '安徽',
  350000: '福建',
  360000: '江西',
  370000: '山东',
  410000: '河南',
  420000: '湖北',
  430000: '湖南',
  440000: '广东',
  450000: '广西',
  460000: '海南',
  500000: '重庆',
  510000: '四川',
  520000: '贵州',
  530000: '云南',
  540000: '西藏',
  610000: '陕西',
  620000: '甘肃',
  630000: '青海',
  640000: '宁夏',
  650000: '新疆',
  710000: '台湾',
  810000: '香港',
  820000: '澳门',
}
export default {
  components: {
    PartTitle,
  },
  data() {
    return {
      coverType: 'year', // 覆盖率类型： 年度覆盖率(year)、本周覆盖率(week)
      dataSource: null,
      coverageList: [],
      REGIONSLIST,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.timeline = new Timeline(this.$refs['time-line'])

      this.initTimeline()
    })
  },
  methods: {
    getData(_period, _type) {
      const year = moment().year()
      const periodType = _type || 2 // quarter
      const month = moment().month() + 1
      let period = _period || null
      if (!period) {
        if (month < 4) {
          period = `${moment().year()}01`
        } else if (month < 7) {
          period = `${moment().year()}02`
        } else if (month < 10) {
          period = `${moment().year()}03`
        } else {
          period = `${moment().year()}04`
        }
      }
      const typeAcquistion = 2 // 采集

      const satelliteGroupId9 = 6 // 可见光（计算覆盖率）
      // 本期覆盖率
      this.$axios.get(GET_STATISTICS({
        year, periodType, period, satelliteGroupId: satelliteGroupId9, type: typeAcquistion,
      })).then((res) => {
        if (res.code === 0 && res.data) {
          const coverList = res.data.children.map((item) => {
            const regionName = this.getRegionName(item.regionId)
            return {
              name: regionName,
              regionId: item.regionId,
              value: (item.coveragePercentCurrent || 0).toFixed(2),
            }
          })
          this.coverageList = coverList
          this.setOption()
        } else if (res.code === 0 && res.data === null) {
          const coverList = []
          Object.keys(REGIONSLIST).forEach((key) => {
            const item = {
              name: REGIONSLIST[key],
              regionId: key,
              value: 0,
            }
            coverList.push(item)
          })
          this.coverageList = coverList
          this.setOption()
        } else {
          throw new Error(res.message)
        }
      }).catch(err => console.log(err))
    },
    initTimeline() {
      const period = moment().format('YYYY0Q')
      const q = `Q${moment().format('Q')}`
      const index = COVERAGE_TIMELINE_DATA.findIndex(i => i.title === q && i.value === period)
      if (_.isArray(COVERAGE_TIMELINE_DATA) && COVERAGE_TIMELINE_DATA.length > 0) {
        this.timeline.init(COVERAGE_TIMELINE_DATA, {
          control: {
            play: {
              show: false,
            },
          },
          // middleHeight: 16,
          middleHeightOffset: -30,
          itemStartIndex: index,
          item: {
            handleChoose: this.timelineChange,
            style: {
              fontSize: 16,
              textFill: '#737373',
              textAlign: 'right',
            },
            size: 12,
          },
        })
      }
    },
    /**
     * 时间周变化
     */
    timelineChange(info, index) {
      this.getData(info.value, info.type, index)
    },
    setOption() {
      const seriesData = this.coverageList.filter(l => l.regionid !== '-')
      const heBei = seriesData.find(i => i.name === '河北')
      heBei.dataLabels = {
        x: -10,
        y: 15,
      }
      const beijing = seriesData.find(i => i.name === '北京')
      beijing.dataLabels = {
        x: 0,
        y: 0,
      }
      const tianjin = seriesData.find(i => i.name === '天津')
      tianjin.dataLabels = {
        x: 10,
        y: 8,
      }
      const guangdong = seriesData.find(i => i.name === '广东')
      guangdong.dataLabels = {
        x: 5,
        y: -8,
      }
      const xianggang = seriesData.find(i => i.name === '香港')
      xianggang.dataLabels = {
        x: 15,
        y: 5,
      }
      const aomen = seriesData.find(i => i.name === '澳门')
      aomen.dataLabels = {
        x: -5,
        y: 10,
      }
      const gansu = seriesData.find(i => i.name === '甘肃')
      gansu.dataLabels = {
        x: 30,
        y: 30,
      }
      const finderN = seriesData.find(i => i.name === '内蒙古')
      finderN.dataLabels = {
        x: 10,
        y: 50,
      }
      const haiNan = seriesData.find(i => i.name === '海南')
      haiNan.dataLabels = {
        x: -45,
        y: -65,
      }
      const fujian = seriesData.find(i => i.name === '福建')
      fujian.dataLabels = {
        x: 5,
        y: 5,
      }
      const jiangsu = seriesData.find(i => i.name === '江苏')
      jiangsu.dataLabels = {
        x: 5,
        y: -5,
      }
      const shanxi = seriesData.find(i => i.name === '陕西')
      shanxi.dataLabels = {
        x: 5,
        y: 20,
      }
      const heilongjiang = seriesData.find(i => i.name === '黑龙江')
      heilongjiang.dataLabels = {
        x: 5,
        y: 15,
      }
      const taiwan = seriesData.find(i => i.name === '台湾')
      taiwan.dataLabels = {
        x: -5,
        y: 5,
      }
      // .map((item) => {
      //   const name = item.regionname
      //   return {
      //     name,
      //     value: item.yearpercent.toFixed(2),
      //   }
      // })

      const series = [
        {
          type: 'map',
          name: 'province',
          color: '#79bdfe',
          mapData: provinceData,
          data: seriesData,
          joinBy: 'name',
          dataLabels: {
            enabled: true,
            color: '#222222',
            borderWidth: 0,
            style: {
              fontSize: 12,
              fontFamily: 'PingFangSC-Regular,PingFang SC',
              fontWeight: 400,
              textOutline: 'unset',
            },
            format: '{point.name}',
          },
          tooltip: {
            headerFormat: '',
            pointFormat: '{point.name}: {point.value}%',
          },
        },
        {
          type: 'map',
          name: 'daoyu',
          color: '#737373',
          mapData: daoyuData,
          tooltip: {
            enabled: false,
          },
        },
        {
          type: 'mapline',
          name: 'guojie',
          color: '#737373',
          lineWidth: 2,
          data: guojieData,
          enableMouseTracking: false,
          tooltip: {
            enabled: false,
          },
        },
      ]
      const option = {
        chart: {
          ignoreHiddenSeries: false,
        },
        title: {
          text: null,
        },
        colorAxis: {
          dataClasses: [
            {
              to: 0,
              color: '#fff', // '#FF403F',
            }, {
              from: 0.001,
              to: 50,
              color: '#FF403F',
            }, {
              from: 50,
              to: 60,
              color: '#FF6940',
            },
            {
              from: 60,
              to: 70,
              color: '#FF9640',
            }, {
              from: 70,
              to: 80,
              color: '#FFBE41',
            }, {
              from: 80,
              to: 90,
              color: '#FFE840',
            }, {
              from: 90,
              to: 92,
              color: '#EBF73F',
            }, {
              from: 92,
              to: 94,
              color: '#C4E842',
            }, {
              from: 94,
              to: 96,
              color: '#A1DB40',
            }, {
              from: 96,
              to: 98,
              color: '#85CB41',
            }, {
              from: 98,
              to: 100,
              color: '#6AC040',
            },
          ],
        },
        credits: {
          enabled: false,
        },
        legend: {
          align: 'left',
          // backgroundColor: 'white',
          floating: true,
          layout: 'vertical',
          verticalAlign: 'bottom',
          // labelFormat: '{from} - {to}',
          // eslint-disable-next-line
          labelFormatter: function(e) {
            if (this.from === undefined) {
              this.legendItem.element.parentNode.style.display = 'none'
              setTimeout(() => {
                this.legendItem.element.parentNode.remove()
              })
            }
            if (this.from === 0.001) {
              return `0 - ${this.to}`
            }
            return `${this.from} - ${this.to}`
          },
          symbolRadius: 3,
          symbolHeight: 18,
          symbolWidth: 30,
          itemMarginTop: 5,
          itemStyle: {
            fontSize: '20px',
            fontFamily: 'Helvetica-Light,Helvetica',
            fontWeight: 300,
            color: '#737373',
          },
          x: 0,
          y: 0,
        },
        series,
      }
      Highcharts.mapChart(this.$refs.hChart, option)
    },
    getRegionName(regionId) {
      const china = REGIONSLIST
      return china[regionId]
    },
  },
}
</script>

<style lang="scss">
// .highcharts-credits {
//   display: none;
// }
.observe-cover-map {
  padding: 0 35px;
  margin-bottom: 10px;
}
.observe-cover-map__map {
  height: 630px;
}
.observe-cover-map__timeline {
  height: 130px;
  margin-top: -10px;
}
g.highcharts-legend-item {
  pointer-events: none;
}
</style>
